import React, { useState } from 'react';
import './Stall.css';

const Stall = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    contactPerson: '',
    email: '',
    phone: '',
    message: ''
  });

  const exhibits = [
    {
      icon: 'flaticon-home',
      title: 'Prime Location',
      description: 'Get your stall in high-traffic areas of the exhibition venue for maximum visibility.'
    },
    {
      icon: 'flaticon-charity',
      title: 'Buyer Access',
      description: 'Connect directly with hosted buyers and thousands of visitors from across India.'
    },
    {
      icon: 'flaticon-kindness',
      title: 'Marketing Support',
      description: 'Leverage our marketing channels to promote your brand and products.'
    },
    {
      icon: 'flaticon-donation',
      title: 'Setup Support',
      description: 'Professional team assistance for stall setup, electrical, and logistics.'
    }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // API call will go here
    alert('Your booking request has been submitted! We will contact you shortly.');
    setFormData({
      companyName: '',
      contactPerson: '',
      email: '',
      phone: '',
      message: ''
    });
  };

  return (
    <>
      {/* Page Header Start */}
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>Stall Booking</h2>
            </div>
            <div className="col-12">
              <a href="/">Home</a>
              <a href="/stall">Stall Booking</a>
            </div>
          </div>
        </div>
      </div>
      {/* Page Header End */}

      {/* Introduction Section */}
      <div className="stall-intro">
        <div className="container">
          <div className="section-header text-center">
            <p>Exhibition Opportunities</p>
            <h2>Book Your Stall at SSVASS</h2>
          </div>
          <div className="intro-content">
            <p>
              SSVASS National Gems & Jewellery Exhibition provides an exceptional platform for jewellers and gemstone dealers to showcase their products to a massive audience of buyers, retailers, and enthusiasts.
            </p>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="stall-benefits">
        <div className="container">
          <div className="section-header text-center">
            <p>Why Exhibit</p>
            <h2>Benefits of Exhibiting with Us</h2>
          </div>
          <div className="benefits-grid">
            {exhibits.map((exhibit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">
                  <i className={exhibit.icon}></i>
                </div>
                <h3>{exhibit.title}</h3>
                <p>{exhibit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Booking Form Section */}
      <div className="stall-booking">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="booking-form-container">
                <div className="section-header">
                  <h2>Book Your Stall</h2>
                  <p>Fill out the form below and our team will contact you within 24 hours</p>
                </div>
                <form onSubmit={handleSubmit} className="booking-form">
                  <div className="form-group">
                    <label htmlFor="companyName">Company Name *</label>
                    <input
                      type="text"
                      id="companyName"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleInputChange}
                      required
                      placeholder="Your company name"
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="contactPerson">Contact Person *</label>
                      <input
                        type="text"
                        id="contactPerson"
                        name="contactPerson"
                        value={formData.contactPerson}
                        onChange={handleInputChange}
                        required
                        placeholder="Full name"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">Email Address *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        placeholder="your@email.com"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">Phone Number *</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      required
                      placeholder="+91 XXXXXXXXXX"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Additional Details</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      placeholder="Tell us more about your business and requirements..."
                      rows="5"
                    ></textarea>
                  </div>

                  <button type="submit" className="btn-submit">
                    Submit Booking Request
                  </button>
                </form>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="booking-info">
                <div className="info-card">
                  <h3>Quick Info</h3>
                  <p>
                    SSVASS National Gems & Jewellery Exhibition is the premier platform for showcasing jewellery and gemstones in India.
                  </p>
                </div>

                <div className="info-card">
                  <h3>Dates</h3>
                  <p>30 Aug to 01 Sep 2026</p>
                </div>

                <div className="info-card">
                  <h3>Venue</h3>
                  <p>
                    Gyan Bhawan<br/>
                    Gandhi Maidan<br/>
                    Patna, Bihar
                  </p>
                </div>

                <div className="info-card contact-card">
                  <h3>Contact Us</h3>
                  <p>
                    <i className="flaticon-phone"></i>
                    +91 XXXXXXXXXX
                  </p>
                  <p>
                    <i className="flaticon-email"></i>
                    info@ssvass.com
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="stall-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Showcase Your Collection?</h2>
            <p>Join hundreds of exhibitors at SSVASS. Book your stall today!</p>
            <a href="/" className="btn-cta">Download Exhibitor Kit</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Stall;
